import React, { Component } from 'react';
import setStroke from '../helpers/setStroke';
import animateValue from '../helpers/animateValue';
import {FacebookShareButton, FacebookIcon} from 'react-share';

class PanelFinished extends Component {
    componentDidMount() {
        //console.log(this.props.ending.exits);
        //this.animateSVG();
    }

    animateSVG() {
        let stats = document.querySelector('.quiz__circle--expand');
        setStroke(stats, this.props.points, this.props.totalPoints);

        setTimeout(() => {
            stats.classList.add('is-animating');
            setStroke(stats, this.props.points, this.props.totalPoints, true);
            animateValue('pointsCount', 0, this.props.points, 1400);
        }, 400)
    }

    render() {
        let exits;
        const facebook = this.props.facebook;

        if(this.props.finish.exits && this.props.finish.exits.length) {
            exits = this.props.finish.exits.map(ending => {

                if(ending.target === 'reset') {
                    return (
                        <button 
                        type="button" 
                        key={ending.text}
                        className={`quiz__button quiz__button--${ending.priority}`}
                        onClick={() => this.props.onClick()}>{ending.text}</button>
                    )
                }

                else if(ending.target === 'facebook') {

                    if(facebook && facebook.url && facebook.url !== "") {
                        let logoFillColor = "white";
                        let iconStyle = {
                            fill: "transparent",
                        }

                        if(ending.priority === 'high') {
                            logoFillColor = "#009f98";
                        }

                        return (
                            <FacebookShareButton 
                            className={`quiz__button quiz__button--share quiz__button--${ending.priority}`}
                            url={facebook.url} 
                            key={ending.text}
                            quote={facebook.quote}>
                            <FacebookIcon className="quiz__icon" size={20} iconBgStyle={iconStyle} logoFillColor={logoFillColor}></FacebookIcon>
                            <span className="quiz__button-text">{ending.text}</span>
                            </FacebookShareButton>
                        )
                    }

                }

                return (
                    <a href={ending.target} key={ending.text} className={`quiz__button quiz__button--${ending.priority}`}>{ending.text}</a>
                )
            })
        }

        return (
            <div className="quiz__finished" data-points={this.props.points}>
                <div className="quiz__content">

                    {/* <svg className="quiz__stats" width="200" height="200" aria-labelledby="pointsTitle pointsCount">
                        <title id="pointsTitle">{this.props.ending.alt}</title>
                        <text className="quiz__points" id="pointsCount" x="100" y="110" textAnchor="middle">{this.props.points}</text>
                        <circle className="quiz__circle quiz__circle--track" cx="100" cy="100" r="80" />
                        <circle className="quiz__circle quiz__circle--expand" cx="100" cy="100" r="80" />
                    </svg> */}

                    <h2 className="quiz__subtitle">{this.props.finish.title}</h2>
                    <p className="quiz__lead">{this.props.finish.text}</p>

                    <div className="quiz__buttons">
                        {exits}
                    </div>
                </div>
            </div>
        );
    }
}

export default PanelFinished;


// WEBPACK FOOTER //
// ./src/components/PanelFinished.js